import { useEffect, useState } from "react";
import { DEMO_DATA } from "../utils/demoData";

const serverUrl = "https://hr-api.infiheal.com/";

const useWorkerStats = (code) => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [parentCode, setParentCode] = useState(null);
  const demo = DEMO_DATA[code];


  useEffect(() => {
     if (demo) return;
    let cancelled = false;
    
    const codeToFetch = localStorage.getItem("c-code") ||  "";

    if (!codeToFetch) return;
    const fetchStats = async () => {
      setLoading(true);
      try {
        // TODO: replace with real endpoint, e.g.
        const res = await fetch(
          `${serverUrl}api/v1/coupon/work-survey/${codeToFetch}`,
        );
        const data = await res.json();
        // console.log(data)
        // const data = { numberOfWorkers: 1470, avgJobSatisfaction: 2.73, workLifeBalance: 2.66 };
        if (!cancelled) setStats(data.data);
      } catch (err) {
        if (!cancelled) setError(err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetchStats();
    return () => {
      cancelled = true;
    };
  }, [code]);
  if (demo) return { stats: demo.workerStats, loading: false, error: null };


  return { stats, loading, error };
};

export default useWorkerStats;
